import React from 'react';
import { Box, Button, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import { RowAction } from '../../../../../components/row-action';
import { getLegalInstrumentTypeLabel } from '../../../../../model/sge/transfer/transfer-enums';
import { formatDocument } from '../../../../../utils/document';
import { formatDate } from '../../../../../utils/date';
import { formatCurrency } from '../../../../../utils/format';
import { AmendmentDetailController } from '../context/amendment-detail-controller';
import { useAmendmentDetailState } from '../context/amendment-detail-context';
import { EmptyRow, dashIfEmpty } from './detail-parts';

export function TransfersTab({ ctrl }: { ctrl: AmendmentDetailController }) {
    const { transfers } = useAmendmentDetailState();

    return (
        <React.Fragment>
            <Box sx={{ display: 'flex', justifyContent: 'flex-end', mb: 1 }}>
                <Button variant="contained" startIcon={<AddIcon />} onClick={() => ctrl.openDrawer('transferDrawer')}>Nova Transferência</Button>
            </Box>
            <TableContainer>
                <Table size="small">
                    <TableHead>
                        <TableRow>
                            <TableCell>Empresa</TableCell>
                            <TableCell>CNPJ</TableCell>
                            <TableCell>Tipo Instrumento</TableCell>
                            <TableCell>Nº Instrumento</TableCell>
                            <TableCell>Data Assinatura</TableCell>
                            <TableCell align="right">Valor</TableCell>
                            <TableCell align="right">Ações</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {transfers.length === 0 && <EmptyRow colSpan={7} message="Nenhuma transferência cadastrada" />}
                        {transfers.map((transfer) => (
                            <TableRow key={transfer.id} hover>
                                <TableCell>{dashIfEmpty(transfer.companyName)}</TableCell>
                                <TableCell>{dashIfEmpty(formatDocument(transfer.cnpj))}</TableCell>
                                <TableCell>{getLegalInstrumentTypeLabel(transfer.legalInstrumentType)}</TableCell>
                                <TableCell>{dashIfEmpty(transfer.instrumentNumber)}</TableCell>
                                <TableCell>{dashIfEmpty(formatDate(transfer.signatureDate))}</TableCell>
                                <TableCell align="right">{formatCurrency(transfer.transferredAmount)}</TableCell>
                                <TableCell align="right">
                                    <Box sx={{ display: 'inline-flex' }}>
                                        <RowAction title="Editar" onClick={() => ctrl.openDrawer('transferDrawer', { record: transfer })}><EditIcon fontSize="small" /></RowAction>
                                        <RowAction title="Excluir" color="error" onClick={() => ctrl.deleteTransfer(transfer)}><DeleteIcon fontSize="small" /></RowAction>
                                    </Box>
                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>
        </React.Fragment>
    );
}
